var map = {
	"./decidim/Inter-Black.woff": 75224,
	"./decidim/Inter-Black.woff2": 69328,
	"./decidim/Inter-BlackItalic.woff": 23032,
	"./decidim/Inter-BlackItalic.woff2": 29160,
	"./decidim/Inter-Bold.woff": 91608,
	"./decidim/Inter-Bold.woff2": 59944,
	"./decidim/Inter-BoldItalic.woff": 10248,
	"./decidim/Inter-BoldItalic.woff2": 17656,
	"./decidim/Inter-ExtraBold.woff": 18544,
	"./decidim/Inter-ExtraBold.woff2": 1232,
	"./decidim/Inter-ExtraBoldItalic.woff": 79672,
	"./decidim/Inter-ExtraBoldItalic.woff2": 51632,
	"./decidim/Inter-ExtraLight.woff": 3292,
	"./decidim/Inter-ExtraLight.woff2": 91576,
	"./decidim/Inter-ExtraLightItalic.woff": 89776,
	"./decidim/Inter-ExtraLightItalic.woff2": 92594,
	"./decidim/Inter-Italic.woff": 92740,
	"./decidim/Inter-Italic.woff2": 11324,
	"./decidim/Inter-Light.woff": 86574,
	"./decidim/Inter-Light.woff2": 35784,
	"./decidim/Inter-LightItalic.woff": 25470,
	"./decidim/Inter-LightItalic.woff2": 2808,
	"./decidim/Inter-Medium.woff": 83096,
	"./decidim/Inter-Medium.woff2": 30304,
	"./decidim/Inter-MediumItalic.woff": 88308,
	"./decidim/Inter-MediumItalic.woff2": 65536,
	"./decidim/Inter-Regular.woff": 89302,
	"./decidim/Inter-Regular.woff2": 74944,
	"./decidim/Inter-SemiBold.woff": 18384,
	"./decidim/Inter-SemiBold.woff2": 48178,
	"./decidim/Inter-SemiBoldItalic.woff": 41684,
	"./decidim/Inter-SemiBoldItalic.woff2": 4712,
	"./decidim/Inter-Thin.woff": 57504,
	"./decidim/Inter-Thin.woff2": 90696,
	"./decidim/Inter-ThinItalic.woff": 2016,
	"./decidim/Inter-ThinItalic.woff2": 66312,
	"./decidim/Inter-italic.var.woff2": 49216,
	"./decidim/Inter-roman.var.woff2": 74144,
	"./decidim/Inter.var.woff2": 28552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19564;